import {DrugItemDrawerTradeNamesSection} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {useSupportiveMedicationDrugContext} from '@/shared/contexts/supportive-medication-drug'
import {Tabs} from '@chakra-ui/react'

export function TradeNamesTab() {
  const {tradeNames} = useSupportiveMedicationDrugContext()

  return (
    <Tabs.Content value="trade-names">
      <DrugItemDrawerTradeNamesSection tradeNames={tradeNames} />
    </Tabs.Content>
  )
}
